// Enumerations
import { UploadIdStatesEnumeration } from 'containers/upload-id/enumerations/upload-id-states.enumeration';
// Translations
import { TRY_AGAIN } from './translations/upload-id-error.handlers.translations';
// Types
import {
  UploadIdErrorBuilderHandlersType,
  UploadIdErrorMethodsHandlersType,
} from './types/upload-id-error.handlers.type';

const retryButtonClickHandler = async ({
  setError,
  setUploadIdState,
  handleTrackTryAgain,
}: Pick<
  UploadIdErrorBuilderHandlersType,
  'setUploadIdState' | 'setError' | 'handleTrackTryAgain'
>): Promise<void> => {
  handleTrackTryAgain();
  setError(false);
  setUploadIdState(UploadIdStatesEnumeration.LANDING);
};

const setupUploadIdErrorButtonConfigurationHandler = ({
  formatMessage,
  setMainButtonConfiguration,
  ...restProps
}: UploadIdErrorBuilderHandlersType): void => {
  setMainButtonConfiguration({
    children: formatMessage({ id: TRY_AGAIN }),
    onClick: () => retryButtonClickHandler(restProps),
  });
};

const UploadIdErrorHandlers = (
  props: UploadIdErrorBuilderHandlersType
): UploadIdErrorMethodsHandlersType => ({
  handleSetupUploadIdErrorButtonConfiguration: () =>
    setupUploadIdErrorButtonConfigurationHandler(props),
});

export { UploadIdErrorHandlers };
